module.exports = __webpack_public_path__ + "media/about/magdalena-kusz-063a9e69.jpg";